<template>
	<div>
		<Top></Top>
		<div class="wd-container ascss">
			<div>
				<el-steps :active="active" finish-status="success" align-center><el-step :title="item" v-for="(item, index) in lclist" :key="index"></el-step></el-steps>
			</div>
			<!-- <div class="rowvalue">
				协商历史
			</div>
			<div class="">
				
			</div> -->
			<div class="rowvalue">申请时间：{{ wddatalist.optdate }}</div>
			<div class="rowvalue">处理类型：{{ wddatalist.flagtext }}</div>
			<div class="rowvalue">退款商品：{{ wddatalist.goodsname }}</div>
			<div class="rowvalue">退款数量：{{ wddatalist.num }}{{ wddatalist.unit }}</div>
			<div class="rowvalue">退款金额：¥{{ $weidajs.numberFixed(wddatalist.amount) }}</div>
			<div class="rowvalue">退款理由：{{ wddatalist.reason }}</div>
			<div class="rowvalue">退款说明：{{ wddatalist.memo }}</div>
			<div class="rowvalue">退款编号：{{ wddatalist.listseqno }}</div>
			<div class="zt wd-p-a-10" v-if="(wddatalist.state == 1 && wddatalist.state == 7) || wddatalist.state == 9">
				<div class=""><span class="wd-theme-666">退款关闭</span></div>
				<div class="wd-m-t-10 wd-m-b-10  wd-theme-333"><span>退款申请已关闭</span></div>
			</div>
			<div class="zt wd-p-a-10 rowvalue" v-if="wddatalist.state == 5 || wddatalist.state == 6">
				<div class="wd-font-16">
					<span class="wd-icon wd-theme wd-m-r-10">&#xe603;</span>
					<span class="wd-theme">退款成功</span>
				</div>
				<div class="wd-m-t-10 wd-m-b-10  "><span>退款金额将原路退还给消费者</span></div>
				<div class="hx"></div>
				<div class="wd-m-t-10 wd-m-b-10  wd-theme-333">实际退款金额：¥{{ wddatalist.amount }}</div>
				<div class=" wd-theme-333">退款时间：{{ wddatalist.backmoneydate }}</div>
			</div>
			<div class="zt wd-p-a-10" v-if="flag == 2 && wddatalist.state == 2">
				<el-divider></el-divider>
				<div class="rowtitle"><span class="wd-theme-666">请退货和填写物流信息</span></div>
				<div class="wd-m-t-10   wd-theme rowvalue">
					<span>还剩下{{ wddatalist.backday }}天{{ wddatalist.backhour }}小时{{ wddatalist.backminute }}分</span>
				</div>

				<div class="wd-m-t-10   wd-theme rowvalue">商家已同意退货申请，请尽早退货</div>
			</div>
			<div class="zt wd-p-a-10" v-if="wddatalist.state == 1">
				<div class="wd-m-b-10"><span class="wd-theme-666">商家拒绝退货</span></div>
				<div class="hx"></div>
				<div class="wd-m-t-10 wd-m-b-10  wd-theme-999" @click="gotorecord">点击协商历史查看详情</div>
			</div>
			<div class="rowvalue wd-p-t-10 wd-p-b-10" v-if="flag == 2 && wddatalist.state > 1">
				<div class="wdmargin-l-10">
					<div>请将货物寄至以下地址：</div>
					<div class="wd-m-t-10 wd-theme-333">
						收货人：{{ backinfo.backman }}
						<span class="wd-m-l-10">收货电话：{{ backinfo.backtelno }}</span>
					</div>
					<div class=" wd-theme-333 wd-m-t-10 wd-m-b-10">
						<span>收货地址：</span>
						<span class="">{{ backinfo.backaddr }}</span>
					</div>
				</div>
				<div class="wd-flex wd-row-left wd-m-t-10 wd-m-b-10 wdflex_rownowrap ">
					<div class="span">请填写退回货物的快递单号:</div>
					<div class="span"><el-input type="text" v-model="expressno" :disabled="wddatalist.state != 2" maxlength="30" placeholder="请输入快递单号" /></div>
				</div>
			</div>
			<div class="wd-p-l-100" v-if="flag == 2 && wddatalist.state == 2 && wddatalist.expressno == ''"><el-button type="primary" @click="save">提交快递单号</el-button></div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
import { mapState } from 'vuex';
export default {
	name: 'Afterservicedetail',
	computed: {
		...mapState(['logininfo'])
	},
	components: {
		Top,
		Footer
	},
	data() {
		return {
			active: 1,
			serviceid: '',
			wddatalist: {},
			backinfo: {},
			expressno: '',
			flag: 0,
			flag2: 'hxd',
			lclist: ['申请退款', '客服审核', '客户退货', '退款完成']
		};
	},
	activated() {
		var e = this.$route.query || '';
		var sid = e.detailid || '';
		if (sid !== this.serviceid) {
			this.serviceid = sid;
			this.loaddata();
		}
	},
	methods: {
		save() {
			if (this.expressno == '') {
				this.$wd_toast('请输入寄回的快递单号');
				return;
			}
			if (this.backinfo == '') {
				this.$wd_toast('商家未设置退货地址，请联系平台客服');
				return;
			}
			var indata = {
				id: this.serviceid,
				expressno: this.expressno,
				backman: this.backinfo.backman,
				backaddr: this.backinfo.backaddr,
				backtelno: this.backinfo.backtelno
			};
			this.$wd_request('afterservice_express', indata)
				.then(() => {
					this.$wd_msg('提交快递单号成功');
					this.wddatalist.state = 3;
				})
				.catch(data => {
					this.$wd_toast(data.msg);
				});
		},
		gotorecord() {
			// this.$wd_goto('afterservicerecord',"mainid="+this.serviceid);
		},
		loaddata() {
			if (this.serviceid == '') {
				this.$wd_toast('操作错误');
				return;
			}
			let indata = {
				id: this.serviceid
			};
			this.$wd_request('afterservicelist', indata)
				.then(data => {
					console.log(data);
					this.wddatalist = data.value;
					this.expressno = data.value.expressno;
					this.flag = data.value.flag;
					var state = parseInt(data.value.state);
					switch (state) {
						case 0:
							this.active = 1;
							break;
						case 1:
							this.active = 2;
							this.lclist[1] = '客服拒绝';
							break;
						case 2:
							this.active = 2;
							break;
						case 3:
							this.active = 3;
							break;
						case 4:
							this.active = 3;
							break;
						case 5:
							this.active = 4;
							break;
						case 6:
							this.active = 4;
							break;
						case 7:
							this.active = 4;
							break;
						case 8:
							this.active = 4;
							break;
						case 9:
							this.active = 4;
							break;
						default:
							1;
					}
					if ((data.value.backaddr || '') == '') {
						this.$wd_request('afterservice_backaddr', indata).then(data => {
							this.backinfo = data.value;
						});
					} else {
						this.backinfo.backaddr = data.value.backaddr;
						this.backinfo.backman = data.value.backman;
						this.backinfo.backtelno = data.value.backtelno;
					}
				})
				.catch(data => {
					this.$wd_toast(data.msg);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.ascss {
	width: 800px;
	margin-top: 50px;
	.rowtitle {
		border-left: 4px solid $wd-theme;
		padding-left: 10px;
		margin: 10px 0;
	}
	.rowvalue {
		margin: 10px 0;
		padding-left: 44px;
		.span {
			width: 200px;
		}
	}
	.btngroup {
		padding-left: 280px;
		margin-top: 30px;
	}
}
</style>
